import { render, staticRenderFns } from "./UsersListSolicitacoes.vue?vue&type=template&id=4c204448&scoped=true&"
import script from "./UsersListSolicitacoes.vue?vue&type=script&lang=js&"
export * from "./UsersListSolicitacoes.vue?vue&type=script&lang=js&"
import style0 from "./UsersListSolicitacoes.vue?vue&type=style&index=0&id=4c204448&prod&lang=scss&scoped=true&"
import style1 from "./UsersListSolicitacoes.vue?vue&type=style&index=1&id=4c204448&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c204448",
  null
  
)

export default component.exports